<template lang="pug">
  vue-good-table(
    ref="table"
    :columns="columns"
    :rows="formattedPayments"
    :pagination-options=`{
      enabled: true,
      perPage: 20,
      nextLabel: $t('pagination.next'),
      prevLabel: $t('pagination.back'),
      rowsPerPageLabel: $t('pagination.output'),
      allLabel: $t('pagination.all'),
      ofLabel: $t('pagination.of'),
    }`
    :sort-options={
      enabled: true,
      initialSortBy: {field: 'created_at',  type: 'desc'}
    }
    @on-column-filter="onColumnFilter"
  )
    div(slot="emptystate") Нет данных
    template(slot="table-row" slot-scope="props")
      span(
        v-if="props.column.field == 'status'"
        :class="getStatusClass(props.index)"
      ) {{ props.formattedRow[props.column.field] }}
      span(
        v-else-if="props.column.field == 'payment' || props.column.field == 'writeoff'"
      )
        span(v-if="props.formattedRow[props.column.field] !== 0") {{ props.formattedRow[props.column.field] | currency }}
      span(v-else) {{ props.formattedRow[props.column.field] }}
</template>

<script>
import { VueGoodTable } from 'vue-good-table';

import config from '@/config';

import table from '@/mixins/table.mixin';

export default {
  mixins: [table],
  props: {
    payments: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'Дата',
          field: 'created_at',
          type: 'date',
          dateInputFormat: config.dateTimeInputFormat,
          dateOutputFormat: config.dateTimeOutputFormat,
          filterOptions: {
            enabled: true,
            placeholder: 'Дата операции',
            filterFn: this.dateRangeFilter
          }
        },
        {
          label: 'Тип платежа',
          field: 'reason_title',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Тип операции', // placeholder for filter input
            filterDropdownItems: ['Оплата тарифа', 'Списание по тарифу']
          }
        },
        {
          label: 'Приход',
          type: 'number',
          field: 'payment'
        },
        {
          label: 'Расход',
          type: 'number',
          field: 'writeoff'
        }
      ]
    };
  },

  computed: {
    formattedPayments() {
      let output = [];
      this.payments.forEach(payment => {
        output.push({
          created_at: payment.created_at,
          amount: payment.amount,
          payment: payment.reason === 'PAYMENT_YANDEX' ? payment.amount : 0,
          writeoff: payment.reason !== 'PAYMENT_YANDEX' ? payment.amount : 0,
          reason: payment.reason,
          reason_title: payment.reason_title
        });
      });
      return output;
    },

    columnsDateInputs() {
      const dateColumns = this.columns.filter(column => column.type === 'date');
      const dateInputs = [];

      dateColumns.forEach(column =>
        dateInputs.push(
          `input[placeholder='${column.filterOptions.placeholder}']`
        )
      );

      return dateInputs;
    }
  },

  methods: {
    getStatusClass(rowIndex) {
      const type = this.payments[rowIndex].statusType;
      switch (type) {
        case 'success':
          return 'payments__success';
        case 'error':
          return 'payments__error';
        default:
          return '';
      }
    }
  },

  components: {
    VueGoodTable
  }
};
</script>

<style lang="scss" scoped>
.payments__success {
  color: green;
}

.payments__error {
  color: red;
}
</style>
